import {css} from '@emotion/react';
import styled from '@emotion/styled';
import {omit} from 'lodash';

type Props = React.PropsWithChildren<{
  width: number;
  height: number;
}>;

export const Tile = styled((props: Props) => (
  <li {...omit(props, 'width', 'height')} />
))(
  ({width, height, theme}) => css`
    box-sizing: border-box;
    padding: 2px;
    flex-shrink: 0;
    width: ${width}%;
    height: ${height}px;
    & > img,
    & > div {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    &:first-of-type {
      padding-top: 0;
    }

    & > div {
      background-color: ${theme.colors.backgroundSecondary};
    }
  `
);
